// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-bucket-pane__Rxxx6YHs{border-radius:$border-radius-panel;box-sizing:border-box;overflow:hidden;position:relative;width:300px}.mp-bucket-pane__Rxxx6YHs .input-pane__wi6xGHZF{width:100%}.mp-bucket-pane__Rxxx6YHs .mp-bucket-pane-btn__df3cFvz6{--button-content-width:auto;display:block;margin-top:8px;padding:0 16px}.mp-bucket-pane__Rxxx6YHs .mp-bucket-pane-btn__df3cFvz6:last-child{padding-bottom:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mpBucketPane": "mp-bucket-pane__Rxxx6YHs",
	"inputPane": "input-pane__wi6xGHZF",
	"mpBucketPaneBtn": "mp-bucket-pane-btn__df3cFvz6"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
